import React from 'react';

import { Avatar, Box, Stack, Typography } from '@mui/material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

import PropTypes from 'prop-types';

import { COLORS } from '../../../Constant/COLORS';

const SingleReview = ({ name, desc }) => {
  return (
    <Box
      sx={{
        height: '100%',
        p: 3,
        border: `1px solid ${COLORS.hairline}`,
        borderRadius: 3,
        bgcolor: COLORS.surface,
        display: 'flex',
        flexDirection: 'column',
      }}>
      <FormatQuoteIcon sx={{ color: COLORS.brass, fontSize: 34, mb: 1 }} />
      <Typography sx={{ fontStyle: 'italic', flexGrow: 1 }} color={COLORS.ink}>
        {desc}
      </Typography>
      <Stack direction='row' alignItems='center' gap={1.5} mt={2.5}>
        <Avatar sx={{ width: 40, height: 40 }} />
        <Typography fontWeight={600}>{name || 'Verified client'}</Typography>
      </Stack>
    </Box>
  );
};

SingleReview.propTypes = {
  src: PropTypes.string,
  name: PropTypes.string,
  job: PropTypes.string,
  desc: PropTypes.string,
};

export default SingleReview;
